import {lib_es_US} from '@docupet/component-library';
import es_US from '@/translations/es-US';

export default {
    ...lib_es_US,
    ...es_US,
};
